export const fontFamily = [
  '游ゴシック Medium',
  '游ゴシック体',
  'Yu Gothic Medium',
  'YuGothic',
  'ヒラギノ角ゴ ProN',
  'Hiragino Kaku Gothic ProN',
  'Noto Sans JP',
  'Lato',
  'メイリオ',
  'Meiryo',
  'ＭＳ Ｐゴシック',
  'MS PGothic',
  'sans-serif'
].join(',');
